// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"181":"202544e8","994":"797d126c"}[chunkId] + ".chunk.js";
};